import { JourneyInterestContainer } from "components/views/fle/journey/JourneyInterestContainer"
import Interests from "utils/Interests"
import React from "react"

const JourneyReceivingCareInterest = ({ history }) => {
  return (
    <JourneyInterestContainer
      title="What type of fertility care are you receiving?"
      somethingElseNext="/fle/journey/receiving-care/something-else"
      history={history}
      interestsToExclude={[
        Interests.UNDERSTAND_MY_FERTILITY,
        Interests.ADOPTING,
        Interests.GESTATIONAL_CARRIER,
        Interests.PREGNANCY
      ]}
    />
  )
}

export { JourneyReceivingCareInterest }
